import React from "react";
import { Row, Col } from "reactstrap";

import DOMPurify from "dompurify";
import {
  getOverlapStatusLabel,
  isConfirmedDuplicate,
} from "common/constants/overlap-status";
import PaymentComparison from "./PaymentComparison";

/**
 * The side-by-side comparison of an overlapping pair plus its resolution.
 *
 * Shared by the quick-view modal and the full details page so the two can't
 * drift apart; it renders bare rows and leaves the surrounding chrome (modal
 * body, card body) to the caller.
 */
const OverlappingPaymentDetails: React.FC<{ record: any }> = ({ record }) => {
  return (
    <>
      <PaymentComparison record={record} />
      <Row>
        <Col md={12} className="mb-4">
          <h6 className="text-muted text-uppercase fw-semibold mb-3">
            Additional Information
          </h6>

          <div className="table-responsive border border-dashed rounded p-2  mb-3">
            <table className="table table-md table-borderless table-striped mb-0">
              <tbody>
                <tr>
                  <td
                    className="fw-medium text-muted"
                    style={{ whiteSpace: "nowrap", width: "25%" }}
                  >
                    What is this payment?
                  </td>
                  <td>
                    <p className="fw-medium mb-0 fs-14">
                      {record?.overlapStatus ? (
                        <span
                          className={`badge fs-12 ${
                            isConfirmedDuplicate(record.overlapStatus)
                              ? "bg-danger-subtle text-danger"
                              : "bg-success-subtle text-success"
                          }`}
                        >
                          {getOverlapStatusLabel(record.overlapStatus)}
                        </span>
                      ) : (
                        <span className="badge bg-secondary-subtle text-secondary fs-12">
                          Not Set
                        </span>
                      )}
                    </p>
                  </td>
                </tr>
                <tr>
                  <td
                    className="fw-medium text-muted"
                    style={{ whiteSpace: "nowrap", width: "25%" }}
                  >
                    Has this overlapping payment been resolved?
                  </td>
                  <td>
                    {record?.resolved ? (
                      <span className="badge bg-success-subtle text-success fs-12">
                        Yes
                      </span>
                    ) : (
                      <span className="badge bg-danger-subtle text-danger fs-12">
                        No
                      </span>
                    )}
                  </td>
                </tr>
                <tr>
                  <td className="fw-medium text-muted">
                    Comments on resolution:
                  </td>
                  <td
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(
                        record?.comments || "Not Provided"
                      ),
                    }}
                  ></td>
                </tr>
              </tbody>
            </table>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default OverlappingPaymentDetails;
